import React from "react";
import { Badge } from "react-bootstrap";

type ToggleProps = {
    children: React.ReactNode;
    onClick: React.MouseEventHandler<HTMLElement>;
    style?: React.CSSProperties;
}
const DropdownToggle = React.forwardRef<HTMLButtonElement, ToggleProps>(
    ({ children, onClick, ...otherProps }, ref) => {
        return (
            <Badge pill bg="info" text="dark" className="tag"
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
                style={{
                    ...(otherProps.style === undefined ? {} : otherProps.style)
                }}
                ref={ref}
            >
                <i className="fa-solid fa-caret-down"></i>
                {children}
            </Badge>
        )
    }
)

export default DropdownToggle;